var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-143 -206) translate(143 206)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M52.496 34.566c-.156-.373-.52-.617-.923-.617H40.637V9c0-.552-.447-.999-.998-.999h-15.97c-.55 0-.997.447-.997.998V33.95H11.693c-.403 0-.766.244-.922.615-.154.373-.07.803.216 1.088l19.91 19.977c.188.188.442.294.707.294.266 0 .52-.106.707-.292L52.28 35.654c.285-.285.371-.715.216-1.088z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_downloading_down",
    attributeName: "transform",
    attributeType: "XML",
    from: "0 0",
    to: "0 5",
    begin: "0s; hinava_random_uuid_downloading_up.end",
    dur: "0.5s",
    type: "translate"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_downloading_up",
    attributeName: "transform",
    attributeType: "XML",
    from: "0 5",
    to: "0 0",
    begin: "hinava_random_uuid_downloading_down.end",
    dur: "0.5s",
    type: "translate"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloading);
export default __webpack_public_path__ + "static/media/downloading.9bef95834a5348f89b3e50324ba2bffe.svg";
export { ForwardRef as ReactComponent };